// StudentTranscriptECsPDF.js
import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

// Styles PDF
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
  },
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 40,
  },
  leftHeader: { flex: 1 },
  rightHeader: { flex: 1, textAlign: "right" },
  title: {
    fontSize: 16,
    textAlign: "center",
    fontWeight: "bold",
    marginBottom: 20,
  },
  studentInfoContainer: {
    marginBottom: 10, // espace avant le tableau
  },
  studentName: {
    fontSize: 12,
    marginBottom: 2,
  },
  studentNumber: {
    fontSize: 12,
  },
  tableContainer: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableHeader: {
    backgroundColor: "#eeeeee",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
    fontWeight: "bold",
  },
  tableCell: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    flex: 1,
  },
  oddRow: { backgroundColor: "#f9f9f9" },
});

// Composant PDF pour relevé des ECs
const StudentTranscriptECsPDF = ({ data }) => {
  return (
    <Document>
      {data.map((student) => (
        <Page style={styles.page} key={student.student_id}>
          {/* ================== HEADER ================== */}
          <View style={styles.headerRow}>
            <View style={styles.leftHeader}>
              <Text>UNIVERSITE DES SCIENCES, DES TECHNIQUES</Text>
              <Text>ET DES TECHNOLOGIES DE BAMAKO : USTTB</Text>
              <Text>FACULTE DE MEDECINE ET D'ODONTO-STOMATOLOGIE : FMOS</Text>
            </View>
            <View style={styles.rightHeader}>
              <Text>République du Mali</Text>
              <Text>Un Peuple - Un But - Une Foi</Text>
            </View>
          </View>

          {/* ================== TITRE ================== */}
          <Text style={styles.title}>RÉLÉVÉE DE NOTE</Text>

          {/* ================== INFO ÉTUDIANT ================== */}
          <View style={styles.studentInfoContainer}>
            <Text style={styles.studentName}>
              Prénom et Nom : {student.first_name} {student.last_name}
            </Text>
            <Text style={styles.studentNumber}>
              Numéro Étudiant : {student.student_number}
            </Text>
          </View>

          {/* ================== TABLE ================== */}
          <View style={styles.tableContainer}>
            {/* Header */}
            <View style={[styles.tableRow, styles.tableHeader]}>
              <Text style={[styles.tableCell, { flex: 2 }]}>EC</Text>
              <Text style={[styles.tableCell, { flex: 1 }]}>Note</Text>
              <Text style={[styles.tableCell, { flex: 1 }]}>Validée</Text>
            </View>

            {/* Rows */}
            {Object.values(student.ues || {}).flatMap((ue) =>
              (ue.ecs || []).map((ec, idx) => (
                <View
                  style={[styles.tableRow, idx % 2 === 1 ? styles.oddRow : null]}
                  key={`${student.student_id}-${ue.ue_id}-${ec.ec_id}`}
                >
                  <Text style={[styles.tableCell, { flex: 2 }]}>{ec.ec_title}</Text>
                  <Text style={[styles.tableCell, { flex: 1 }]}>{ec.ec_note}</Text>
                  <Text style={[styles.tableCell, { flex: 1 }]}>
                    {ec.ec_valid ? "Oui" : "Non"}
                  </Text>
                </View>
              ))
            )}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default StudentTranscriptECsPDF;